<template>
  <section>
    <v-col cols="12">
      <v-row
        class="basic-search"
        :class="{
          'mb-3': displayAdvancedSearch,
          'minimal-height': !displayAdvancedSearch,
        }"
      >
        <slot name="basic-search" />
        <v-btn
          id="listFilters-btn-advancedSearch"
          class="ma-0 advanced-search-btn"
          color="secondary"
          :disabled="loading"
          @click="toggleAdvancedSearch"
        >
          <div class="advanced-search-btn-content">
            <v-tooltip top v-if="showAdvancedSearchDirtyIcon">
              <template v-slot:activator="{ props }">
                <v-icon color="white" v-bind="props">mdi-information</v-icon>
                {{ displayAdvancedSearch ? $t("buttons.HIDE_ADVANCED_SEARCH") : $t("buttons.SHOW_ADVANCED_SEARCH") }}
              </template>
              <span>{{ $t('messages.CONTAINS_ADVANCED_SEARCH') }}</span>
            </v-tooltip>
            <span v-else>
              {{ displayAdvancedSearch ? $t("buttons.HIDE_ADVANCED_SEARCH") : $t("buttons.SHOW_ADVANCED_SEARCH") }}
            </span>
          </div>
        </v-btn>
      </v-row>
    </v-col>

    <v-col cols="12" class="pa-0" v-if="displayAdvancedSearch">
      <v-row>
        <slot name="advanced-search" />
      </v-row>
    </v-col>

    <v-col
      cols="12"
      class="text-center py-0 advanced-search-btn-mobile"
      :class="{ 'pt-3': displayAdvancedSearch }"
    >
      <v-btn
        id="listFilters-btn-advancedSearch"
        class="ma-1"
        color="secondary"
        :disabled="loading"
        @click="toggleAdvancedSearch"
      >
        <div class="advanced-search-btn-content">
          <v-tooltip top v-if="showAdvancedSearchDirtyIcon">
            <template v-slot:activator="{ props }">
              <v-icon color="white" v-bind="props">mdi-information</v-icon>
              {{ displayAdvancedSearch ? $t("buttons.HIDE_ADVANCED_SEARCH") : $t("buttons.SHOW_ADVANCED_SEARCH") }}
            </template>
            <span>{{ $t('messages.CONTAINS_ADVANCED_SEARCH') }}</span>
          </v-tooltip>
          <span v-else>
            {{ displayAdvancedSearch ? $t("buttons.HIDE_ADVANCED_SEARCH") : $t("buttons.SHOW_ADVANCED_SEARCH") }}
          </span>
        </div>
      </v-btn>
    </v-col>
  </section>
</template>

<script lang="ts">
import { defineComponent, VNode } from 'vue';

export default defineComponent({
  name: 'AdvancedSearchComponent',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      displayAdvancedSearch: false,
    };
  },
  methods: {
    toggleAdvancedSearch(): void {
      this.displayAdvancedSearch = !this.displayAdvancedSearch;
    },
  },
  computed: {
    inputFields(): string[] {
      if (this.$slots['advanced-search'] && Array.isArray(this.$slots['advanced-search'])) {
        return this.$slots['advanced-search']
          .filter((node: VNode) => node.children)
          .map((node: VNode) => {
            /* eslint-disable @typescript-eslint/no-explicit-any */
            const vNode: any = node.children;
            if (vNode && Array.isArray(vNode)) {
              return Array.isArray(vNode[0].data?.model.value)
                ? vNode[0].data?.model.value.join(',')
                : vNode[0].data?.model.value;
            }
            return [];
          });
      }
      return [];
    },
    showAdvancedSearchDirtyIcon(): boolean {
      return this.inputFields.some((v) => v) && !this.displayAdvancedSearch;
    },
  },
});
</script>

<style lang="scss" scoped>
:deep(.v-select__selection) {
  height: 20px;
}
:deep([class^="col"]) {
  padding-top: 0;
  padding-bottom: 0;
}
.advanced-search-btn {
  top: 0px;
  height: 55px !important;
  @media (max-width: 675px) {
    display: none;
  }
}
.advanced-search-btn-content {
  display: flex;
  align-items: center;
  gap: 8px;
}
.advanced-search-btn-mobile {
  display: none;
  @media (max-width: 675px) {
    display: block;
  }
}
.minimal-height {
  @media (min-width: 676px) {
    height: 48px;
  }
}
.basic-search {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: nowrap;
  @media (min-width: 600px) {
    flex-direction: row;
    gap: 24px;
  }
}
</style>
